/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router'
import { titleoptions } from '../../../api/dummyData'
import {
  HelpIcon,
} from '../../../assets/AppIcons'
import { AppStyles } from '../../../assets/styles/AppStyles'
import FormInput from '../../../components/inputs/FormInput'
import {
  getProfile,
  getIsOurCustomer,
} from '../../../redux/Actions/getMethods'
import {
  editMyProfileAfterSignUp,
} from '../../../redux/Actions/postMethods'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import { useTheme } from '../../../utils/ThemeColorContext'

import PageHeader from '../../../components/PageHeader'
import Spinner from '../../../components/Spinner'
import SpinnerLarge from '../../../components/SpinnerLarge'
import SubPageHeader from '../../../components/SubPageHeader'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import DatePicker from '../../../components/inputs/DatePicker'
import FormSelect from '../../../components/inputs/FormSelect'
import OnEnter from '../../../components/navigation/onEnter'
import DefaultPage from '../DefaultPage'
import JourneyRoute from '../../../navigation/JourneyRoute'
import TagManager from 'react-gtm-module'

const initialvalues = {
  title: '',
  first_name: '',
  surname: '',
  date: '',
  email: '',
  birthday: '',
}

function YourDetails() {
  const {
    loading,
    loading2,
  } = useSelector((state) => state.authReducer)
  const dispatch = useDispatch()
  const { profile, loadingWholeScreen, isOurCustomer } = useSelector(
    (state) => state.dataReducer,
  )

  const { color, isSmallScreen } = useTheme()

  const navigate = useNavigate()
  const [values, setValues] = useState(initialvalues)


  const [selectedDate, setSelectedDate] = useState(null)
  const [scrollToCalendar, setScrollToCalendar] = useState(null)

  const location = useLocation()

  useEffect(() => {
    const fetchProfile = async () => {
      await dispatch(getProfile())
    }
    fetchProfile()
  }, [])

  const handleDateChange = (selectedDate) => {
    setSelectedDate(selectedDate)
    const date = new Date(selectedDate)
    const birthday = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    setValues({
      ...values,
      birthday: birthday,
    })
  }
  // ================== Format Date 2023-12-28 =======================//
  const date = new Date(selectedDate)
  const formattedDate = `${date.getFullYear()}-${String(
    date.getMonth() + 1,
  ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  // ================== Formate Date 2023-12-28 =======================//

  const handleChange = (e) => {
    const { name, value } = e.target // e.target refers to the input element
    let trimmed = value?.trim()
    setValues({
      ...values, // spread the existing values
      [name]: trimmed ? trimmed : value, // override the value for the input's name
    })
  }

  function areAllValuesEmpty(obj) {
    for (let key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key) &&
          (obj[key] !== '' 
            && (key === 'phone' && obj[key] !== '07')
          )
      ) {
        return false
      }
    }
    return true
  }
  useEffect(() => {
    if (!areAllValuesEmpty(values)) {
      sessionStorage.setItem(`user`, JSON.stringify(values))
      sessionStorage.setItem(`birth`, new Date(selectedDate))
    }
  }, [values, selectedDate])

  useEffect(() => {
    if (profile?.id) {
      if (profile?.title !== '') {
        setValues({
          title: {
            label: profile?.title,
            value: profile?.title,
          },
          first_name: profile?.first_name,
          surname: profile?.family_name,
        })
      }
      setSelectedDate(new Date(profile?.birthday))
    }
  }, [profile?.id])
  
  const handleUpdateProfile = async () => {
    const birthday = profile?.birthday ? profile?.birthday : formattedDate
    const first_name = profile?.first_name ? profile?.first_name : values?.first_name
    const surname = profile?.family_name ? profile?.family_name : values?.surname
    const title = profile?.title ? profile?.title : values?.title
    const data = {
      birthday: birthday,
      first_name: first_name,
      surname: surname,
      title: title,
    }
    const updated = await dispatch(editMyProfileAfterSignUp(data))
    if (updated) {
      const getPro = await dispatch(getProfile())
      if (getPro) {
        dispatch({ type: ActionTypes.LOADING_FAIL2 })
        let isUserOurCustomer = null
        if (isOurCustomer == null || isOurCustomer === undefined) {
          isUserOurCustomer = await dispatch(getIsOurCustomer())
        } else {
          isUserOurCustomer = isOurCustomer
        }
        if (isUserOurCustomer === true) {
          navigate('/marketing-permissions')
        } else {
          navigate('/address-detail')
        }
      }
    } else {
      // same behaviour for now
      const getPro = await dispatch(getProfile())
      if (getPro) {
        dispatch({ type: ActionTypes.LOADING_FAIL2 })
        let isUserOurCustomer = null
        if (isOurCustomer == null || isOurCustomer === undefined) {
          isUserOurCustomer = await dispatch(getIsOurCustomer())
        } else {
          isUserOurCustomer = isOurCustomer
        }
        if (isUserOurCustomer === true) {
          navigate('/marketing-permissions')
        } else {
          navigate('/address-detail')
        }
      }
    }
  }

  const adultDate = new Date().setFullYear(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate() + 1)

  const selectDateRef = useRef(null)
  const scrollToSelectDate = () => {
    if (selectDateRef.current) {
      selectDateRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }
  useEffect(() => {
    if (scrollToCalendar != null && isSmallScreen) {
      scrollToSelectDate()
    }
  }, [scrollToCalendar])

  const [openCalendar, setOpenCalendar] = useState(null)
  const surnameRef = useRef(null)

  return (
    <DefaultPage>
      <JourneyRoute />
      {loadingWholeScreen ? (
        <SpinnerLarge />
      ) : (
        <>
          <div className="relative container mx-auto md:w-[564px] md:space-y-10 ">
            <PageHeader
              title={'About you'}
              description={
                'Update a few simple details to get your eligibility check up and running.'
              }
            />
            <div
              style={{
                backgroundColor: color.White,
              }}
              className=" rounded-3xl p-6 space-y-10 "
            >
              {/* personal details */}
              <div className=" space-y-6">
                <div style={{ marginBottom: isSmallScreen && '24px' }}>
                  <SubPageHeader
                    // width={isSmallScreen && '131px'}
                    Icon={HelpIcon}
                    text={'Personal details'}
                  />
                </div>
                <div className="flex flex-col space-y-6 w-full">
                  <>
                    <div className="w-full flex flex-col space-y-6 ">
                      { !profile?.title && (
                        <div className="flex flex-col justify-end space-y-6 w-full">
                          <FormSelect
                            options={titleoptions}
                            placeholder={'Title'}
                            type={'select'}
                            onChange={(val) =>
                              setValues({ ...values, title: val })
                            }
                            name={'title'}
                            value={values.title}
                          />
                        </div>
                      )}
                      { !profile?.first_name && (
                        <div className="flex flex-col justify-end space-y-6 w-full">
                          <FormInput
                            placeholder={'First name'}
                            type={'text'}
                            onChange={(e) => handleChange(e)}
                            name={'first_name'}
                            autoComplete={'given-name'}
                            value={values.first_name}
                          />
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col space-y-6">
                      { !profile?.family_name && (
                        <div className="flex flex-col justify-end space-y-6 w-full" ref={selectDateRef}>
                          <FormInput
                            placeholder={'Surname'}
                            type={'text'}
                            onChange={(e) => handleChange(e)}
                            name={'surname'}
                            autoComplete={'family-name'}
                            value={values.surname}
                            enterKeyHint={'done'}
                            ref={surnameRef}
                            onKeyDown={(e) => {
                              const inputValue = e.key
                              if (inputValue === 'Enter' || inputValue === 'Tab') {
                                surnameRef.current?.blur()
                                e.preventDefault()
                                setOpenCalendar(!openCalendar)
                              }
                            }}
                          />
                        </div>
                      )}
                      <div className="flex flex-col justify-end space-y-6 w-full disable-dbl-tap-zoom">
                        { !profile?.birthday && (
                          <div className="space-y-1">
                            <DatePicker
                              placeholder={'Date of birth'}
                              date={selectedDate}
                              onDateChange={handleDateChange}
                              onCalendarOpen={() => setScrollToCalendar(!scrollToCalendar)}
                              openCalendar={openCalendar}
                            />
                            { selectedDate && selectedDate >= adultDate && (
                              <p style={{ color: '#FF619A' }}>
                              You need to be at least 18 years old to continue
                            </p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
            <div
              className="w-[90%] md:w-[full]"
              style={{ margin: isSmallScreen && 'auto' }}
            >
              <b style={{ ...AppStyles.Caption1, color: color.SoftPink }}>

              </b>
            </div>
            <OnEnter
              actionFunction={() => {
                if (!values.title ||
                  !values.first_name ||
                  !selectedDate ||
                  !values.surname
                ) {
                  return
                }
                const tagManagerArgs = {
                  dataLayer: {
                    event: 'onenter-about-you',
                    page: location?.pathname,
                  }
                }
                TagManager.dataLayer(tagManagerArgs)
                handleUpdateProfile()
              }}
            />
            <div
              style={{
                marginTop: isSmallScreen && '24px',
                background: !isSmallScreen && 'linear-gradient(0deg, #F5F7FC 0%, rgba(245, 247, 252, 0) 100%)',
              }}
              className={
                isSmallScreen ? (
                  `mt-10 md:max-w-[588px] m-[auto] fixed w-full bottom-0 px-6 pb-6 md:p-0 flex ${
                    profile?.id ? 'justify-center items-center' : ''
                  } flex-col-reverse gap-5 md:gap-10 md:flex-row bg-[#F5F7FC]`
                ) : (
                  `mt-10 md:max-w-[588px] m-[auto] fixed md:relative w-full bottom-0  px-6 pb-6 md:p-0 flex ${
                    profile?.id && 'justify-center items-center'
                  } flex-col-reverse gap-5 md:gap-10 md:flex-row `
                )
              }
            >
              {isSmallScreen && (
                <>
                  <div
                    className="absolute inset-x-0 top-[-32px] h-[24px] bg-gradient-to-t from-[#F5F7FC] to-[#F5F7FC00] pointer-events-none"
                  ></div>
                  <div
                    className="absolute inset-x-0 top-[-8px] h-[8px] bg-[#F5F7FC] pointer-events-none"
                  />
                </>
              )}
              <PrimaryButton
                id={'login-in-about-you'}
                text={loading || loading2 ? <Spinner /> : 'Continue'}
                disabled={
                  (!profile?.title && !values.title) ||
                  (!profile?.first_name && !values.first_name) ||
                  (!profile?.birthday && 
                    (!selectedDate ||
                    selectedDate >= adultDate)) ||
                  (!profile?.family_name && !values.surname)
                }
                onClick={async () => {
                  if (loading || loading2) {
                    return
                  }
                  handleUpdateProfile()
                }}
                className={' w-full md:w-[260px]'}
              />
            </div>
          </div>
        </>
      )}
    </DefaultPage>
  )
}

export default YourDetails
